import { ColorName, StatusType } from 'types';

type Status = {
  background: ColorName;
  color: ColorName;
  label: string;
};

const useStatus = () => {
  const chooseStatus = (status: StatusType): Status => {
    switch (status) {
      case 'ACCEPTED':
        return {
          background: 'accepted',
          color: 'acceptedFont',
          label: 'accepted',
        };
      case 'IN_PROGRESS':
        return {
          background: 'inProgress',
          color: 'inProgressFont',
          label: 'in progress',
        };
      case 'IN_REVIEW':
        return {
          background: 'inReview',
          color: 'inReviewFont',
          label: 'in review',
        };
      case 'REFUSED':
        return {
          background: 'refused',
          color: 'refusedFont',
          label: 'refused',
        };
      case 'ABANDONED':
        return {
          background: 'abandoned',
          color: 'abandonedFont',
          label: 'abandoned',
        };
      case 'NEW':
        return {
          background: 'new',
          color: 'white',
          label: 'new',
        };
      case 'DELETED':
        return {
          background: 'deleted',
          color: 'deletedFont',
          label: 'deleted',
        };
      case 'DELETE_REQUESTED':
        return {
          background: 'deleteRequested',
          color: 'deleteRequestedFont',
          label: 'delete requested',
        };
      default:
        return {
          background: 'black',
          color: 'white',
          label: 'No status',
        };
    }
  };

  return {
    chooseStatus,
  };
};

export { useStatus };
